import React from "react";
import PageShell from "../components/PageShell";
import PageHero from "../components/PageHero";
import Work from "../components/Work";
import CallToAction from "../components/CallToAction";

export default function WorkPage() {
  return (
    <PageShell>
      <PageHero
        eyebrow="◇ Selected Work"
        title="Things we've shipped."
        accent="shipped."
        kicker="A small selection of products and systems we've designed, built and operated with our clients."
      />
      <Work />
      <CallToAction
        eyebrow="◇ Next"
        title="Want to be the next one here?"
        body="We pick a small number of partners each quarter. Slots for Q1 are open."
        ctaLabel="Send a brief"
      />
    </PageShell>
  );
}
